<template>
  <div class="page">
    <div class="container">
      <router-link class="page-back" to>
        <i class="mintui mintui-back back-btn" @click="onBack"></i>
      </router-link>
      <h1>{{course_name}}</h1>
      <div class="line"></div>
      <Table :columns="columns" :data="list" border disabled-hover :loading="loading"></Table>
    </div>
  </div>
</template>
<script>
export default {
  name: "ErrorDetail",
  data() {
    return {
      loading: false,
      columns: [
        {
          title: "错误名称",
          align: "center",
          key: "error_name"
        },
        {
          title: "出错次数",
          align: "center",
          key: "error_count"
        }
      ],
      list: []
    };
  },
  created() {
    let data = this.$route.params.data;
    if (!data || !data.error_map) return;
    if (data) {
      this.loading = true;
      this.updateView(data);
    }
  },
  methods: {
    updateView(data) {
      let course_name = data.course_name;
      this.course_name = course_name;

      let error_map = data.error_map;
      let list = [];
      for (let key in error_map) {
        let value = error_map[key];
        let row = {};
        row.error_name = key;
        row.error_count = value;
        list.push(row);
      }
      this.list = list;

      this.loading = false;
    },
    onBack() {
      this.$router.back(-1);
    }
  }
};
</script>

<style scoped>
.page {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  background-color: #eff3f6;
  overflow: scroll;
}
.container {
  width: 95%;
  font-size: 26px;
  display: flex;
  flex-flow: column nowrap;
  margin: 0px auto 50px auto;
}
.line {
  border-bottom: 1px solid #e8eaec;
  margin-bottom: 20px;
}
>>> .ivu-table th {
  background-color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/ErrorDetail.vue